<app-header [forceLightBackground]="true"></app-header>
<div class="provider-add-dataset-new">
  <div class="provider-add-dataset-new--layout">
    <app-provider-sidebar class="provider-add-dataset-new--sidebar"></app-provider-sidebar>
    <div class="provider-add-dataset-new--content">
      <div class="provider-add-dataset-new--body">
        <app-page-header [showDivider]="false"></app-page-header>
      </div>
      <hr class="provider-add-dataset-new--title-divider" />
      <div class="provider-add-dataset-new--body">
        <div class="page-container">
          <lib-onboarding-home
            publisherRole="provider"
            (submitError)="onSubmitError($event)"
            (submitSuccess)="onSubmitSuccess($event)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
